import { Hours } from 'components/organisms/user-capacity';

export enum SubmissionHoursConstrainType {
  IsEmpty = 'isEmpty',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  Equals = 'value',
}
type BaseSubmissionHoursProp = {
  value: Hours;
};
type SubmissionHoursIsEmptyConstrain = {
  constraintType: SubmissionHoursConstrainType.IsEmpty;
};
type SubmissionHoursGreaterThanConstrain = BaseSubmissionHoursProp & {
  constraintType: SubmissionHoursConstrainType.GreaterThan;
};
type SubmissionHoursLessThanConstrain = BaseSubmissionHoursProp & {
  constraintType: SubmissionHoursConstrainType.LessThan;
};
type SubmissionHoursEqualsConstrain = BaseSubmissionHoursProp & {
  constraintType: SubmissionHoursConstrainType.Equals;
};

export type SubmissionHoursConfiguration =
  | SubmissionHoursIsEmptyConstrain
  | SubmissionHoursGreaterThanConstrain
  | SubmissionHoursLessThanConstrain
  | SubmissionHoursEqualsConstrain;
